import { Form } from "@redriver/cinnamon-mui";
import { getClientContacts } from "./actions";

const ClientContactTypeAhead = ({
  clientId,
  contractId,
  clientOfficeIds = [],
  jobId,
  projectId,
  ...props
}) => (
  <Form.TypeAhead
    {...props}
    lookupAction={getClientContacts}
    lookupParams={{ clientId, contractId, clientOfficeIds, jobId, projectId }}
  />
);

export default ClientContactTypeAhead;
